export default {
  REGISTER_WIDTH(state, widthCards) {
    state.widthCards = widthCards;
  },
  ALTER_VALUES_MODAL_DIALOG_GENERAL(state, item) {
    state.dataModalDialogGeneral.nameModal = item.nameModal
    state.dataModalDialogGeneral.title = item.title
    state.dataModalDialogGeneral.subTitle = item.subTitle
    state.dataModalDialogGeneral.footerTitle = item.footerTitle
    state.dataModalDialogGeneral.leftButtonText = item.leftButtonText
    state.dataModalDialogGeneral.rightButtonText = item.rightButtonText
  },
  DATA_COMPANY(state, payload) {
    state.dataCompany = payload;
  },
  DATA_CONTRACT(state, payload) {
    state.dataContract = payload;
  },
  ALTER_SIZE_MODAL_BIG_BOX(state, item) {
    state.sizeModalBigBox = item;
  },
  ALTER_SIZE_MODAL(state, item) {
    state.sizeModal = item;
  },
  ALTER_SIZE_MODAL_REGISTER(state, item) {
    state.sizeModalRegister = item;
  },
  ALTER_MODAL_CONTAINER_BIG_BOX(state, item) {
    state.modalContainerBigBox = item
  },
  ALTER_MODAL_CONTAINER_GENERAL(state, item) {
    state.modalContainerGeneral = item
  },
  ALTER_MODAL_CONTAINER_REGISTER(state, item) {
    state.modalContainer = item
  },
  ALTER_SIZE_MODAL_FINANCIAL(state, item) {
    state.sizeModalFinancial = item;
  },
  ALTER_SIZE_MODAL_CASHIER(state, item) {
    state.sizeModalCashier = item;
  },
  ALTER_MODAL_CONTAINER_FINANCIAL(state, item) {
    state.modalContainerFinancial = item
  },
  ALTER_MODAL_CONTAINER_CASHIER(state, item) {
    state.modalContainerCashier = item
  },
  ALTER_TYPE_DOCUMENT(state, item) {
    state.typeDocument = {
      frenteDeCaixa: false,
      orcamento: false,
      venda: false,
      orcamentoMtq: false,
      vendaMtq: false,
      inspect: false,
      [item]: true,
    };
  },
  ALTER_TYPE_METER_DOCUMENT(state, item) {
    state.typeMeterDocument = {
      orcamentoMtq: false,
      vendaMtq: false,
      orcamentoMtl: false,
      vendaMtl: false,
      [item]: true,
    };
  },
  ALTER_TYPE_FISCAL(state, item) {
    state.typeFiscal = {
      nfe: false,
      nfce: false,
      nfse: false,
      mdfe: false,
      [item]: true,
    };
  },
  ALTER_TYPE_FINANCIAL(state, item) {
    state.enableModalsFinancial = {
      toPay: false,
      toReceive: false,
      billDetails: false,
      [item]: true,
    };
  },
  ALTER_TYPE_PURCHASE(state, item) {
    state.enableModalsPurchase = {
      purchase: false,
      dfe: false,
      [item]: true,
    }
  },
  ALTER_TYPE_ACCOUNTING_CONVERSATION(state) {
    state.enableModalAccountingConversation = !state.enableModalAccountingConversation
  },
  SET_NAV_ITEM_SELECTED(state, item) {
    state.navItemSelected = item;
  },
  SET_DEFAULT_TYPE_FISCAL(state) {
    state.typeFiscal = {
      nfe: false,
      nfce: false,
      nfse: false,
      mdfe: false,
    };
  },
  SET_DEFAULT_TYPE_FINANCIAL(state) {
    state.enableModalsFinancial = {
      toPay: false,
      toReceive: false,
    };
  },
  SET_DEFAULT_TYPE_PURCHASE(state) {
    state.enableModalsPurchase = {
      purchase: false,
      dfe: false,
    };
  },
  SET_COLAPSE_BIG_BOX(state, item) {
    state.colapseBigBox = item
  },
  SET_COLAPSE_FINANCIAL(state, item) {
    state.colapseFinancial = item
  },
  SET_COLAPSE_CASHIER(state, item) {
    state.colapseCashier = item
  },
  SET_COLAPSE_PRINT(state, item) {
    state.colapsePrint = item
  },
  SET_COLAPSE_FISCAL(state, item) {
    state.colapseFiscal = item
  },
  SET_COLAPSE_REGISTER(state, item) {
    state.colapseRegister = item
  },
  SET_COLAPSE_GENERAL(state, item) {
    state.colapseGeneral = item
  },
  SET_HTML_TO_PRINT(state, payload) {
    state.htmlToPrint = payload
  },
  SET_DATA_SEARCH_FROM_BOX_FRONT(state, payload) {
    state.dataSearchFromBoxFront = payload
  },
  SET_DATA_SEARCH_FROM_SALE(state, payload) {
    state.dataSearchFromSale = payload
  },
  SET_DATA_SEARCH_FROM_INSPECT(state, payload) {
    state.dataSearchFromInspect = payload
  },
  SET_DATA_SEARCH_FROM_SALE_SQUARE_METER(state, payload) {
    state.dataSearchFromSquareMeter = payload
  },
  SET_DATA_SEARCH_FROM_PROVISION_SERVICE(state, payload) {
    state.dataSearchFromProvisionService = payload
  },
  SET_DATA_SEARCH_FROM_PRODUCTION_ORDER(state, payload) {
    state.dataSearchFromProductionOrder = payload
  },
  SET_DATA_SEARCH_FROM_MDFE(state, payload) {
    state.dataSearchFromMdfe = payload
  },
  SET_DATA_SEARCH_FROM_PURCHASE(state, payload) {
    state.dataSearchFromPurchase = payload
  },
  SET_DATA_SEARCH_FROM_MOVIMENT_PESTICIDES(state, payload) {
    state.dataSearchFromMovimentPesticides = payload
  },
  SET_DATA_SEARCH_FROM_BILL(state, payload) {
    state.dataSearchFromBill = payload
  },
  SET_DATA_SEARCH_FROM_CUSTOMER(state, payload) {
    state.dataSearchCustomer = payload
  },
  SET_DATA_SEARCH_FROM_EMPLOYEE(state, payload) {
    state.dataSearchEmployee = payload
  },
  SET_DATA_SEARCH_FROM_APPLICATOR(state, payload) {
    state.dataSearchApplicator = payload
  },
  SET_DATA_SEARCH_FROM_RESPONSIBLE(state, payload) {
    state.dataSearchResponsible = payload
  },
  SET_DATA_SEARCH_FROM_PRODUCT(state, payload) {
    state.dataSearchProduct = payload
  },
  SET_DATA_SEARCH_FROM_SUPPLIER(state, payload) {
    state.dataSearchSupplier = payload
  },
  SET_DATA_SEARCH_FROM_SERVICE(state, payload) {
    state.dataSearchService = payload
  },
  SET_DATA_NFE(state, payload) {
    state.dataNFe = payload
  },
  SET_DATA_CONFIG(state, payload) {
    state.dataConfig = payload
  },
  SET_IS_ENABLE_MTQ(state, item) {
    state.enableMtq = item
  },
  SET_SAFE_REGISTER(state, payload) {
    state.dataSafeIsOpen = payload
  },
  SET_IS_SEARCH_BILLS(state) {
    state.isSearchBills = !state.isSearchBills
  },
  SET_IS_SEARCH_REGISTERS(state) {
    state.isSearchRegisters = !state.isSearchRegisters
  },
  SET_SAFE_REMAINING_VALUE(state, item) {
    state.remainingValue = item
  },
  SET_ACCOUTING_CONVERSATIONS(state, payload) {
    state.accountingConversations = payload
  },
  SET_ACCOUTING_NUMBER_NEW_MESSAGES(state, item) {
    state.numberOfNewMessages = item
  },
  SET_OVERFLOW(state, item) {
    state.overflow = item
  },
  SET_PLAN(state, payload) {
    state.dataPlan = payload
  },
  SET_INTERVAL_MACHINE_ID(state, item) {
    state.intervalMachineId = item
  },
  SET_SALE_INTERVAL_MACHINE_ID(state, item) {
    state.saleIntervalMachineId = item
  },
  SET_SALE_ID(state, item) {
    state.saleId = item
  },
  SET_SALE_SQUARE_METER_ID(state, item) {
    state.productionOrderSaleSquareMeterId = item
  },
  SET_ID_TRANSFORM_COMPLETED_SALE(state, item) {
    state.idTransformCompletedSale = item
  },
  ALTER_TYPE_REGISTER(state, item) {
    state.typeRegister = {
      customer: false,
      employee: false,
      applicator: false,
      products: false,
      supplier: false,
      responsible: false,
      [item]: true,
    };
  },

  ALTER_TYPE_SETTINGS(state, item) {
    state.enableModalsSettings = {
      accessControl: false,
      fiscalSettings: false,
      logsScreen: false,
      responsible: false,
      [item]: true,
    }
  },
  SET_NEW_CONSULTATIONS_TAB(state, payload) {
    state.tabListConsultations.forEach(tab => (tab.isSelected = false));

    const newTab = {
      idList: Date.now() + Math.random(),
      text: payload.text,
      value: payload.value,
      isSelected: true,
      pesticideData: payload.pesticideData || null,
    };

    state.tabListConsultations.push(newTab);
  },
  SET_TAB_CONSULTATIONS_SELECTED(state, item) {
    console.log(item)
    state.tabListConsultations = state.tabListConsultations.map(tab => {
      if (tab.idList === item)
        tab.isSelected = true
      else
        tab.isSelected = false

      return tab
    })
  },
  REMOVE_CONSULTATION_TAB(state, tabId) {
    const index = state.tabListConsultations.findIndex(tab => tab.idList === tabId);
    if (index !== -1) {
      const wasSelected = state.tabListConsultations[index].isSelected;
      state.tabListConsultations.splice(index, 1);
      if (wasSelected && state.tabListConsultations.length > 0) {
        state.tabListConsultations[0].isSelected = true;
      }
    }
  },
  TOGGLE_DISCOUNT(state, item) {
    state.discountIsChecked = typeof item === 'boolean' ? item : !state.discountIsChecked
  },
  SET_COMPANY_DATA_LOADED(state, item) {
    state.companyDataLoaded = item
  },
  SET_PLAN_DATA_LOADED(state, item) {
    state.planDataLoaded = item
  },
  SET_IFRAME_URL_BOLETO(state, item) {
    state.urlIframeBoleto = item
  }
};
